var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.2,0.9v1.8H1.8V0.9h3.1L5.8,0h4.4l0.9,0.9H14.2z M2.7,14.2V3.5h10.7v10.7c0,0.5-0.2,0.9-0.5,1.2C12.4,15.8,12,16,11.5,16\n\tH4.4c-0.5,0-0.9-0.2-1.2-0.5C2.8,15.1,2.7,14.7,2.7,14.2L2.7,14.2z","fill":"currentColor"}));
}

Trash.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Trash;

Trash.default = Trash;
